import { STATUS_CODE } from '@kc-console/core';

export const FULL_PAGE_STATUS_CODE: number[] = [
  STATUS_CODE.SERVICE_UNAVAILABLE,
  STATUS_CODE.INTERNAL_SERVER_ERROR,
  STATUS_CODE.NOT_FOUND,
  STATUS_CODE.SESSION_TIMEOUT,
];

export const WITH_GNB_STATUS_CODE: number[] = [
  STATUS_CODE.NOT_FOUND_SERVICE,
  STATUS_CODE.FORBIDDEN_REGION,
  STATUS_CODE.INTERNAL_SERVER_ERROR_WITH_GNB,
];

export const ONLY_COMPONENT_STATUS_CODE: number[] = [
  STATUS_CODE.FORBIDDEN_REGION_SUB,
  STATUS_CODE.FORBIDDEN_DOMAIN,
  STATUS_CODE.FORBIDDEN_PROJECT,
  STATUS_CODE.NOT_FOUND_ROUTE,
  STATUS_CODE.INTERNAL_SERVER_ERROR_IN_SERVICE,
];

export const MODAL_STATUS_CODE: number[] = [STATUS_CODE.UNAUTHORIZED_EXPIRED_TOKEN];

export const UNRECOVERABLE_STATUS_CODE: number[] = [
  STATUS_CODE.SERVICE_UNAVAILABLE,
  STATUS_CODE.INTERNAL_SERVER_ERROR,
  STATUS_CODE.NOT_FOUND,
  STATUS_CODE.SESSION_TIMEOUT,
  STATUS_CODE.UNAUTHORIZED_EXPIRED_TOKEN,
];
